import {
  getAdditionalCompensationField,
  isEmployeeColumnKey,
} from "@/types/employees/employee-column.types.ts";
import { ApiEmployeeAdditionalCompensation } from "@/types/employees/employee-additional-compensation.types.ts";

/**
 * Значение поля доп. компенсации по ключу `employee.additional_compensation.<поле>`.
 * Строк у сотрудника может быть несколько, поэтому значение читается из одной
 * переданной строки, а список собирает вызывающий код.
 */
export function getEmployeeAdditionalCompensationValue(
  columnId: string,
  item: ApiEmployeeAdditionalCompensation
): unknown {
  switch (getAdditionalCompensationField(columnId)) {
    case "amount_gross":
      return item.amount_gross;
    case "amount_net":
      return item.amount_net;
    case "currency":
      return item.currency;
    case "compensation_type":
      return item.compensation_type?.title ?? null;
    case "effective_from":
      return item.date_effective_from;
    case "description":
      return item.description;
    case "comment":
      return item.comment;
    default:
      return null;
  }
}

/**
 * `load_columns` для запроса поиска: ключи выбранных колонок. Не передавать
 * список нельзя — иначе бэк вернёт прежний ответ без строк таблиц и доп.
 * компенсаций, а именно они нужны новым колонкам.
 *
 * Отфильтровано всё, что не является ключом каталога: закреплённая колонка
 * имени живёт на legacy-id, а неизвестный ключ бэк отвергает с 422
 * `employee_column_not_available`. Имя, фото и id приходят всегда и в
 * перечислении не нуждаются.
 */
export function buildLoadColumns(columnIds: string[]): string[] {
  return Array.from(new Set(columnIds.filter((id) => isEmployeeColumnKey(id))));
}
